import { Card }                from 'antd';
import { observer }            from 'mobx-react';
import { FileOutlined }        from '@ant-design/icons';
import { standDashboardStore } from 'stores/index';
import Status                  from '../Status';
import PlanSelect              from './PlanSelect';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import MessageMediaModel       from 'models/MessageMediaModel';

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

interface StandDashboardPlansBoxProps {
  fetchParentData: () => void;
}

const StandDashboardPlansBox = observer(({
  fetchParentData,
}: StandDashboardPlansBoxProps) => {
  const {
    collMessageMedia,
    stand,
  } = standDashboardStore;

  return (
    <Card
      className="accented-shadow"
      title={
        <div>
          <FileOutlined style={styleIcon} /> <FormattedMessageWrapper id="Plans" />
        </div>
      }
    >
      <Status additionalClass="status-big" status={stand.get('status', 1)} />

      <div style={{ height: 10 }} />

      {collMessageMedia.map((messageMedia: MessageMediaModel) => {
        if (!messageMedia.get('enabled')) {
          return null;
        }

        return (
          <div key={messageMedia.get('id')} style={{ marginBottom: 10 }}>
            <PlanSelect
              key={messageMedia.get('id')}
              media={messageMedia}
              onMediaDelete={() => fetchParentData()}
            />
            <br />
          </div>
        );
      })}
    </Card>
  );
});

export default StandDashboardPlansBox;
